module.exports = __webpack_public_path__ + "media/audio29.0cd1686d.mp3";